import slice from './slice';

export const { resetOrderInfo } = slice.actions;

export { fetchPaymentDataThunk as fetchPaymentData } from './thunks';
